import React from "react";
import NACell from "../Reusable/DataTable/NACell";
import DataTable from "../Reusable/DataTable";
import APIS from "../../constant/Endpoint";
import AccessControl from "../../helpers/accessControl";
import SwitchButton from "../Reusable/SwitchButton";

const FiscalYear = (props: any) => {
  const { handleIsActive } = props;
  const defultColumns = [
    { header: "Fiscal Year", accessorKey: "code", cell: NACell },
    { header: "Start Date(AD)", accessorKey: "start_ad", cell: NACell },
    { header: "End Date(AD)", accessorKey: "end_ad", cell: NACell },
    { header: "Start Date(BS)", accessorKey: "start_bs", cell: NACell },
    { header: "End Date(BS)", accessorKey: "end_bs", cell: NACell },
    {
      header: "Default",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div onClick={(e) => e.stopPropagation()}>
          <SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={false}
            onChange={handleIsActive}
          />
        </div>
      ),
    },
  ];
  return (
    <>
      <DataTable
        url={APIS.FISCAL_YEAR}
        queryKey={"fiscal-years"}
        columns={defultColumns}
        params={{}}
        // addNewPagePath={"/create"}
        tableName={"fiscal-year-list"}
        // onRowClick={handleRowClick}
      />
    </>
  );
};

export default FiscalYear;
